module.exports = __webpack_public_path__ + "img/image 20.162bde3e.png";